import { z } from "zod";
export const carouselPlanSchema = z
    .object({
    mode: z.enum(["direct", "press_one"]).default("direct"),
    introAudioId: z.string().regex(/^[a-z0-9-]{1,80}$/).nullable().default(null),
    dispatcherIds: z.array(z.string().regex(/^[1-9][0-9]{0,18}$/)).max(50),
    sourceIds: z.array(z.number().int().positive()).max(200),
    maxConcurrent: z.number().int().min(1).max(20),
    dialTimeoutSec: z.number().int().min(15).max(60),
    dailyAttemptCap: z.number().int().min(1).max(5000),
    attemptsPerNumberDay: z.number().int().min(1).max(6),
    retryAfterMinutes: z.number().int().min(30).max(1440),
    detectionMode: z.enum(["off", "passive", "active"]),
    windowStart: z.number().int().min(0).max(23),
    windowEnd: z.number().int().min(1).max(24),
    unknownTimezone: z.enum(["skip", "moscow"]),
    detectorAttemptKop: z.number().int().min(0).max(5000).default(30),
    detectorTrialDays: z.literal(7).default(7),
    detectorTrialStart: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .refine((value) => {
        const date = new Date(value + "T00:00:00Z");
        return (Number.isFinite(date.getTime()) &&
            date.toISOString().slice(0, 10) === value);
    }, "Некорректная дата начала")
        .nullable()
        .default(null),
    maxCallerWaitSec: z.number().int().min(1).max(10).default(5),
    pauseAfterUnconnected: z.number().int().min(1).max(5).default(1),
    pauseAfterErrors: z.number().int().min(1).max(10).default(3),
})
    .strict()
    .superRefine((p, c) => {
    if (p.windowEnd <= p.windowStart)
        c.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["windowEnd"],
            message: "Конец окна должен быть позже начала",
        });
    if (new Set(p.dispatcherIds).size !== p.dispatcherIds.length)
        c.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["dispatcherIds"],
            message: "Повтор сотрудника",
        });
    if (new Set(p.sourceIds).size !== p.sourceIds.length)
        c.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["sourceIds"],
            message: "Повтор источника",
        });
});
export const carouselPlanSaveSchema = z
    .object({
    revision: z.number().int().nonnegative(),
    config: carouselPlanSchema,
})
    .strict();
export const defaultCarouselPlan = {
    mode: "direct",
    introAudioId: null,
    dispatcherIds: [],
    sourceIds: [],
    maxConcurrent: 2,
    dialTimeoutSec: 30,
    dailyAttemptCap: 100,
    attemptsPerNumberDay: 2,
    retryAfterMinutes: 120,
    detectionMode: "passive",
    windowStart: 9,
    windowEnd: 19,
    unknownTimezone: "skip",
    detectorAttemptKop: 30,
    detectorTrialDays: 7,
    detectorTrialStart: null,
    maxCallerWaitSec: 5,
    pauseAfterUnconnected: 1,
    pauseAfterErrors: 3,
};
/** Conservative scheme: one place includes ringing, detection, bridge and wrap-up. */
export function carouselPlannedCapacity(selected, unavailable, limit) {
    if (![selected, unavailable, limit].every(Number.isFinite))
        return 0;
    return Math.max(0, Math.min(Math.max(0, selected), Math.max(0, limit)) -
        Math.max(0, unavailable));
}
//# sourceMappingURL=carousel-plan.dto.js.map